const getURLParams = (entries, paramKey) => {
    const params = new URLSearchParams(entries);
    const paramValue = params.get(paramKey);
    return paramValue;
};
export default getURLParams;
//# sourceMappingURL=index.js.map